import { Tooltip } from '@nextui-org/react';
import React from 'react';

import { ThemeProp } from '../../theme/Themes';
import Avatar from '../Avatar';
import { BasicInfoBox } from './VehicleCard';
import {
  InfoBoxImageAndValuesContainer,
  InfoBoxImageContainer,
  InfoBoxImagesContainer,
  InfoBoxTitle,
  InfoBoxValue,
  InfoBoxValueContainer,
  InfoBoxValuesContainer,
  NotDisplayedImagesIcon,
  PeopleTooltipContainer,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';

const renderTooltipContent = (data: PersonData) => (
  <InfoBoxImageAndValuesContainer>
    {data.imageUrl && (
      <InfoBoxImageContainer>
        <Avatar size="sm" width="2.125rem" height="2.125rem" src={data.imageUrl} borderRadius="3.125rem" />
      </InfoBoxImageContainer>
    )}
    <InfoBoxValuesContainer $type="company">
      <InfoBoxValueContainer>
        <InfoBoxValue>{data.value1}</InfoBoxValue>
      </InfoBoxValueContainer>
      <InfoBoxValueContainer>
        <InfoBoxValue color={(props: ThemeProp) => props.theme.colors.greyscale.c600}>{data.value2}</InfoBoxValue>
      </InfoBoxValueContainer>
    </InfoBoxValuesContainer>
  </InfoBoxImageAndValuesContainer>
);

interface PersonData {
  value1: string;
  value2: string;
  imageUrl: string;
}

export interface PeopleBox extends BasicInfoBox {
  people: Array<PersonData>;
}

const VehiclePeopleBox = ({ data }: { data: PeopleBox }) => (
  <VehicleInfoBoxContainer>
    {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
    <InfoBoxImagesContainer>
      {data.people.slice(0, 3).map((person, index) => (
        <Avatar
          key={index}
          size="sm"
          width="2.125rem"
          height="2.125rem"
          src={person.imageUrl}
          borderRadius="3.125rem"
        />
      ))}
      {data.people.length > 3 && (
        <Tooltip
          css={{
            padding: 0,
          }}
          content={
            <PeopleTooltipContainer>
              {data.people.slice(3).map((person) => renderTooltipContent(person))}
            </PeopleTooltipContainer>
          }
          hideArrow
          placement="bottom"
        >
          <NotDisplayedImagesIcon>{`+${data.people.length - 3}`}</NotDisplayedImagesIcon>
        </Tooltip>
      )}
    </InfoBoxImagesContainer>
  </VehicleInfoBoxContainer>
);

export default VehiclePeopleBox;
